import { FokParameterType } from '@fora-monorepo/employer-my-pages-common/types';

import { DittoKeys } from '../../i18n/i18n';

export const getParameterTKeys = (
  parameterValue: FokParameterType | string
): {
  name: DittoKeys;
  description: DittoKeys;
  checkboxLabel: DittoKeys;
  parameterSetInfo: DittoKeys;
  activeLabel: DittoKeys;
} => {
  switch (parameterValue) {
    case FokParameterType.KPAfter65:
      return {
        name: 'tooltips.fokParameterKp65.name',
        description: 'tooltips.fokParameterKp65.description',
        checkboxLabel: 'panel.editParameter.checkboxKp65',
        parameterSetInfo: 'tooltips.fokParameterKp65.description',
        activeLabel: 'panel.editParameter.kp65IsActive',
      };
    case FokParameterType.AvtalspensionSAFLOAfter65:
    default:
      return {
        name: 'tooltips.fokParameterAsl65.name',
        description: 'tooltips.fokParameterAsl65.description',
        checkboxLabel: 'panel.editParameter.checkboxAsl65',
        parameterSetInfo: 'tooltips.fokParameterAsl65.description',
        activeLabel: 'panel.editParameter.asl65IsActive',
      };
  }
};
